import * as types from "../../constants";
import * as location from "../../services/locationService";
import * as API from "../../services/APIService";
const route = "api/Locids/";

export function getLocation(SiteID) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_LOCATION_PENDING });
    return location
      .getLocationService(SiteID)
      .then((response) => {
        dispatch({
          type: types.FETCH_LOCATION_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_LOCATION_ERROR });
        throw error;
      });
  };
}

export function getLocations() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_LOCATION_PENDING });
    return API.get(route)
      .then((response) => {
        dispatch({
          type: types.FETCH_LOCATION_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_LOCATION_ERROR });
        throw error;
      });
  };
}

export function getLocationDetails() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_LOCATION_PENDING });
    return location
      .getLocationDetails()
      .then((response) => {
        dispatch({
          type: types.FETCH_LOCATION_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.FETCH_LOCATION_ERROR });
        throw error;
      });
  };
}

export function insertLocation(event) {
  return async (dispatch) => {
    dispatch({ type: types.INSERT_LOCATION_PENDING });
    return API.insert(route, event)
      .then((response) => {
        dispatch({
          type: types.INSERT_LOCATION_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.INSERT_LOCATION_ERROR });
        throw error;
      });
  };
}

export function updateLocation(event) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_LOCATION_PENDING });
    return API.update(route, event)
      .then((response) => {
        dispatch({
          type: types.UPDATE_LOCATION_SUCCESS,
          payload: response,
        });
      })
      .catch((error) => {
        dispatch({ type: types.UPDATE_LOCATION_ERROR });
        throw error;
      });
  };
}
